import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { PAGE_PROPS } from "../constants/common";
import { USERS_INITIAL_STATE } from "../constants/users.constants";
import { IUserItem } from "../../Components/users/types";

export const getAllUsers = createAsyncThunk("users/getAll", async () => {
  const response = await axios.get("/Auth/GetAllUsers");
  return response.data;
});

export const addUser = createAsyncThunk(
  "users/create",
  async (data: Partial<IUserItem>) => {
    const response = await axios.post("/Auth/RegisterUser", data);
    return response.data;
  }
);

export const updateUser = createAsyncThunk(
  "users/update",
  async (data: Partial<IUserItem>) => {
    const response = await axios.post("/Auth/UpdateUser", data);
    return response.data;
  }
);

export const usersSlice = createSlice({
  name: "users",
  initialState: USERS_INITIAL_STATE,
  reducers: {
    onChangeUsersScreen: (state, action) => {
      state.currentScreen = action.payload;
    },
    onChangeUserList: (state, action) => {
      state.pageProps = action.payload;
    },
    onSelectUser: (state, action) => {
      state.selectedUser = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload?.result || PAGE_PROPS;
        state.error = null;
      })
      .addCase(getAllUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "An error occurred.";
      })
      .addCase(addUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(addUser.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(addUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "An error occurred.";
      })
      .addCase(updateUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "An error occurred.";
      });
  },
});

export const { onChangeUsersScreen, onChangeUserList, onSelectUser } =
  usersSlice.actions;

export default usersSlice.reducer;
